import { render, staticRenderFns } from "./InvoiceAlert.vue?vue&type=template&id=a35bc924&scoped=true"
import script from "./InvoiceAlert.vue?vue&type=script&lang=js"
export * from "./InvoiceAlert.vue?vue&type=script&lang=js"
import style0 from "./InvoiceAlert.vue?vue&type=style&index=0&id=a35bc924&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a35bc924",
  null
  
)

export default component.exports